import { defineComponent as _defineComponent } from 'vue'
import { computed, PropType } from "vue";
import { IBusStop } from "@/domain/entities/busStop";


const __default__ = {
  name: "BusStopTimeRow",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  busStop: {
    type: Object as PropType<IBusStop>,
    required: true,
  },
  arrivalTime: {
    type: String,
  },
  isInsideShuttle: {
    type: Boolean,
    default: false,
  },
  isLastRow: {
    type: Boolean,
    default: false,
  },
},
  emits: ["toggleSelectBusStop", "onClickBusStopLocation", "onClickGetOffBell", "onClickScheduleBtn"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;

const emit = __emit;

const arrivalTimeText = computed(() => {
  return props.busStop.isPassByStop() ? "미정차" : props.arrivalTime;
});

const __returned__ = { props, emit, arrivalTimeText }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})